import { mdiCheckboxBlankCircleOutline } from '@mdi/js'

const themeConfig = {
  app: {
    name: 'Ship2Me',
    logo: require('@/assets/images/svg/logo.svg'),
    isDark: false,
    isRtl: false,
    contentLayoutNav: 'vertical', // vertical, horizontal
    routeTransition: 'scroll-x-transition', // https://vuetifyjs.com/en/styles/transitions/#api
    // ! `semi-dark` isn't available for horizontal nav menu
    skinVariant: 'default', // default, bordered, semi-dark
    contentWidth: 'full', // boxed, full
  },
  menu: {
    isMenuHidden: false,
    isVerticalNavMini: false,
    verticalMenuAccordion: true,
    groupChildIcon: mdiCheckboxBlankCircleOutline,
    horizontalNavMenuGroupOpenOnHover: true,
  },
  appBar: {
    /*
    ! In Content Layout Horizontal Nav type `hidden` value won't work
    ! In Content Layout Horizontal Nav type value of `type` will affect both Appbar and Horizontal Navigation Menu
    */
    type: 'static', // fixed, static, hidden
    isBlurred: true,
  },
  footer: {
    type: 'static', // fixed, static, hidden
  },
  themes: {
    light: {
      // primary: '#9155FD',
      // accent: '#0d6efd',
      primary: '#009DA0',
      accent: '#0ccef0',
      secondary: '#8A8D93',
      success: '#56CA00',
      info: '#16B1FF',
      warning: '#FFB400',
      error: '#FF4C51',

      // Colors for Order Status
      Active: '#009DA0',
      Additional: '#FFB400',
      Archived: '#16B1FF',
      Complete: '#16B1FF',
      Held: '#FF4C51',
      InManifest: '#16B1FF',
      Pending: '#009DA0',
      Quote: '#16B1FF',
      QuotePending: '#FFB400',
      Ready: '#56CA00',
      Cancelled: '#443333',
      Checkout: '#443333',
      Destroyed: '#FF4C51',
      ToDestroy: '#FF4C51',
      CheckedOut: '#8A8D93',
            Paid: '#56CA00',

    },
    dark: {
      // primary: '#9155FD',
      // accent: '#0d6efd',
      primary: '#009DA0',
      accent: '#E5F5F5',
      secondary: '#8A8D93',
      success: '#56CA00',
      info: '#16B1FF',
      warning: '#FFB400',
      error: '#FF4C51',

      // Colors for Order Status
      Active: '#009DA0',
      Additional: '#FFB400',
      Archived: '#16B1FF',
      Complete: '#16B1FF',
      Held: '#FF4C51',
      InManifest: '#16B1FF',
      Pending: '#009DA0',
      Quote: '#16B1FF',
      QuotePending: '#FFB400',
      Ready: '#56CA00',
      Cancelled: '#443333',
      Checkout: '#443333',
      Destroyed: '#FF4C51',
      ToDestroy: '#FF4C51',
      CheckedOut: '#8A8D93',
      Paid: '#56CA00',
    },
  },
}

export default themeConfig
